import Helper from "../plugins/Helper/Helper"
export class DocumentItem {
  constructor(item , mainIsVatInclusive , vatPercent, projectCode, type, exchangeRate){
    this.accountingProduct = item.accountingProduct
    this.area = item.area
    this.meter = item.meter
    this.billingSetting = item.billingSetting
    this.dailyBillingSetting = item.dailyBillingSetting
    this.detail = item.detail || ""
    this.name = item.name || ""
    this.isVatInclusive = item.isVatInclusive || mainIsVatInclusive
    this.originalPricePerUnit = item.originalPricePerUnit || 0
    this.setMainIsVatInclusive = mainIsVatInclusive
    this.quantity = item.quantity || 0
    this.sellVatType = item.sellVatType || 1
    this.unit = item.unit
    this.vatPercent = vatPercent || 7
    this.projectCode = projectCode
    this.whtPercent = item.whtPercent || 0
    this.type = type || item.type
    this.discountType = item.discountType || 1
    this.discountPerUnit = item.discountPerUnit || 0
    this.exchangeRate = exchangeRate || 1
  }

  set setMainIsVatInclusive(isVatInclusive){
    this.mainIsVatInclusive = isVatInclusive
    if(this.sellVatType == 1){
      if(isVatInclusive && !this.isVatInclusive){
        this.originalPricePerUnit += Helper.round(this.originalPricePerUnit * this.vatPercent / 100)
      }else if(!isVatInclusive && this.isVatInclusive){
        this.originalPricePerUnit -= Helper.round(this.originalPricePerUnit * this.vatPercent / (100 + this.vatPercent))
      }
    }
    this.isVatInclusive = isVatInclusive
  }
  
  get totalVatValue(){
    let vat = 0
    if(this.sellVatType == 1){
      if(this.isVatInclusive){
        vat = ((this.totalValue * this.vatPercent) / (100 + this.vatPercent)) || 0
      }else{
        vat = (this.pricePerUnit * this.vatPercent / 100) * this.quantity || 0
      }
    }
    return Helper.round(vat)
  }

  get totalValue(){
    let total = 0
    if (this.mainIsVatInclusive) {
      total = this.pricePerUnit * this.quantity
      if ((this.meter || this.type == 'facility') && this.projectCode && this.projectCode == 'tlt') {
        return Helper.roundFacilityCost(total)
      } else {
        return Helper.round(total)
      }
    } else {
      total = (this.pricePerUnit * this.quantity) + this.totalVatValue
      return Helper.round(total)
    }
  }

  get totalOriginalValue(){
    if(this.mainIsVatInclusive){
      return this.totalValue
    }else{
      return Helper.round(this.pricePerUnit * this.quantity)
    }
  }

  get totalNonVatValue(){
    return Helper.round(this.totalValue - this.totalVatValue)
  }

  get totalWhtValue(){
    if(this.whtPercent > 0){
      return Helper.round((this.totalNonVatValue * (this.whtPercent / 100)))
    }else{
      return 0
    }
  }

  get originalDiscountPerUnit(){
    if(this.discountType == 1){
      return this.discountPerUnit || 0
    }else{
      return (this.originalPricePerUnit * this.discountPerUnit / 100)
    }
  }
  
  get pricePerUnit(){
    return ((this.originalPricePerUnit - this.originalDiscountPerUnit) || 0) * this.exchangeRate
  }

  get totalDiscountValue(){
    if (this.mainIsVatInclusive) {
      return Helper.round(this.originalDiscountPerUnit * this.quantity)
    } else {
      return Helper.round((this.originalDiscountPerUnit * this.quantity) + this.totalDiscountVatValue)
    }
  }

  get totalDiscountVatValue(){
    let vat = 0
    if(this.sellVatType == 1 && this.type == "discount"){
      if(this.isVatInclusive){
        vat = ((this.totalDiscountValue * this.vatPercent) / (100 + this.vatPercent)) || 0
      }else{
        vat = (this.originalDiscountPerUnit * this.vatPercent / 100) * this.quantity || 0
      }
    }
    return Helper.round(vat)
  }

  get totalDiscountNonVatValue(){
    return Helper.round(this.totalDiscountValue - this.totalDiscountVatValue)
  }
}